// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"142":"e919f9c2","807":"96d71956"}[chunkId] + ".css";
};